import { render, staticRenderFns } from "./waterLevelThree.vue?vue&type=template&id=8bf6a8b8&scoped=true&"
import script from "./waterLevelThree.vue?vue&type=script&lang=js&"
export * from "./waterLevelThree.vue?vue&type=script&lang=js&"
import style0 from "./waterLevelThree.vue?vue&type=style&index=0&id=8bf6a8b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf6a8b8",
  null
  
)

export default component.exports